<script>
    import IconGame from '@/components/icon/IconGame.vue';
    import constants from '@/constants/index.js';

    export default {
        data() {
            return {
                constants: constants,
            }
        },
        components: {
            ButtonIcon: IconGame,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container"
        :to="{name: constants.ROUTER_NAME.PROVIDERANDGAMEEDIT}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Providers & Games</label>
        </div>
    </router-link>
</template>